/* istanbul ignore file */
export interface UserDetails {
  userId: string;
  userName: string;
  state: string;
  businessUnit: WMMSBusinessUnit;
}

export enum WMMSBusinessUnit {
  WALMART_STORE = "WMT Store",
  WALMART_VISION_STORE = "WMT Vision Center",
  WALMART_PHARMACY = "WMT Pharmacy",
  SAMS_CLUB = "SAM’s Club",
  SAMS_OPTICAL_CENTER = "SAM’s Optical Center",
  SAMS_PHARMACY = "SAM’s Pharmacy",
  HOME_OFFICE = "Home-Office",
  LEGAL = "Legal",
  CLAIMS = "Claims",
  BENEFITS = "Benefits",
  DC_FC = "Distribution/Fulfillment Center",
  OTHER = "Other",
  ANY = "Any",
}

export interface AppState {
  domain: string;
  userDetails: UserDetails;
  authSign:any;
  headers: any; 
  sessionId: string;
  currentQuestion: string;
  genAIWaiting: boolean;
  genAIResponse: GenerativeSearchResponse;
  querySearchLog: QuerySearchLog;
  documentPaths: Map<string, string>;
}
export interface QuerySearch {
  queryId: string;
  sessionId: string;
  userId: string;
  state: string;
  queryType: QueryType;
  query: string;
  response: string;
  businessUnit: string;
  createdTimestamp: string; //UTC timestamp
  respReceivedTimestamp?: string; //UTC timestamp
}
export interface QuerySearchLog extends QuerySearch {
  isSourceClicked: boolean;
  isResponseCopied: boolean;
  isTicketRaised: boolean;
}

export interface logRequest {
  sessionId: string;
  queryId: string;
  userId: string;
  state: string;
  queryType: QueryType;
  query: string;
  response: string;
  businessUnit: string;
  createdTimestamp: string; //UTC timestamp
}

export interface GenerativeSearchResponse {
  response: GenAISearchResponse;
  source_documents: SourceDocument[];
}

export interface SourceDocument {
  text: string;
  document: string;
  url: string;
  name?: string;
  docLink?: string;
  fileid?: string;
}

export interface GenerativeSearchReq {
  query: string;
  metadata: {
    domain: string; //eWMMS,
    query_id: string;
    session_id: string;
    user_id: string;
    business_unit: string; //WMT Store
  };
}

export interface GenAISearchResponse {
  Answer: string;
  Alt_Questions: string[];
}

export interface GenerativeSearchResponse {
  response: GenAISearchResponse;
  source_documents: SourceDocument[];
}

export enum QueryType {
  TYPED = "typedQuery",
  SIMILAR = "similarQuery",
  FREQUENTLY_USED = "frequentlyUsedQuery",
}

export enum FeedbackTags {
  WRONG_INFORMATION = "Wrong Information",
  BAD_SOURCE = "Bad Citation",
  IRRELEVANT = "Irrelevant",
  TOO_LONG = "Too Long",
  INCOMPLETE_ANSWER = "Incomplete Answer",
  SLOW = "Slow",
}

export interface QueryFeedback extends Feedback {
  queryId: string;
  sessionId: string;
  createdTimestamp: string; //UTC timestamp
}

export interface Feedback {
  rating?: number; // [1,5]
  isWrongInformation?: boolean;
  isBadSource?: boolean;
  isResponseRelevant?: boolean;
  isResponseTooLong?: boolean;
  isResponseIncomplete?: boolean;
  isResponseSlow?: boolean;
  comment?: string;
  queryId: string;
  sessionId: string;
}

export interface DropdownOptions {
  label: string;
  value: string;
}
